import { useMemo } from 'react';

import type { TranscriptFormattingPort } from '@/shared-responder-v2-core';

import {
  createTranscriptFormattingPort,
  type TranscriptFormatQueryResult,
} from './shared-responder-v2-transcript-format-port';
import {
  toTranscriptFormatQueryInput,
  type TranscriptFormatQueryInput,
} from './shared-responder-v2-transcript-format.helpers';

export function useTranscriptFormattingPortFromQuery(
  executeQuery: (options: {
    readonly variables: { readonly input: TranscriptFormatQueryInput };
  }) => Promise<TranscriptFormatQueryResult>
): TranscriptFormattingPort {
  return useMemo(
    () =>
      createTranscriptFormattingPort((transcript) =>
        executeQuery({
          variables: { input: toTranscriptFormatQueryInput(transcript) },
        })
      ),
    [executeQuery]
  );
}
